(function () {
    'use strict';

    angular.module("imApp").factory("currencyExRateHistService", ['$ihttp', function ($ihttp) {
        let service = {
            listHistory: function (parms) {
                return $ihttp.post({
                    method: 1025,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
